<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.revenue_billing_cycle" 
                            label="Billing Cycle"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.revenue_management_aum" 
                            label="Management AUM"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.revenue_financial_plans" 
                            label="Financial Plans"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-if="insuranceBasedListings.includes(editData.listing_type)"
                            v-model="editData.revenue_open_enrollment" 
                            label="Open Enrollment"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.revenue_average_fee_charged" 
                            :label="insuranceBasedListings.includes(editData.listing_type) ? 'Average Premium Paid' : 'Average Fee Charged'"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="editData.revenue_family_accounts" 
                            label="Family Accounts"
                            hint="Separate mutliple lines with a semi-colon"
                            persistent-hint>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="editData.revenue_other_notes"
                            label="Other Revenue Notes"
                            auto-grow
                            rows="5" >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'OtherRevenueDetails',
        props: [
            'editData',
            'insuranceBasedListings'
        ]
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/OtherRevenueDetails.vue